/**
 * 详情
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/14      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import {Spin, Empty, Tooltip, Button, message,InputNumber} from "antd";
import PageCommon from  "@components/PageCommon/PageCommon";

import {getRandomString} from "@utils/utils";
import "./index.less";
import qs from "query-string";
import SmallPo from "./components/SmallPo";
import Lang from "@/components/Lang/Lang";
// import ProdRequirementsDrawer from "@/components/orderRequirementsRemarks/prodRequirementsDrawer";
import { numberWithCommas } from "../../../utils/number-util";
import List from "./components/List";
import {isEmpty } from '@utils/utils';
import Cookie from "@utils/cookie";

class PoDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            //数据源
            cancelItemList: [],
            itemList: [],
            registerCancelItemList:[],
            registerCancelData:{

            },
            //po单头数据源
            model: {},
            extra: {},
            fxUserId:"",
        };
        this.params = {
            poId: (qs.parse(props.location.search) || {}).id,
        };
    }

    /**
     * 获取数据源
     */
    getData() {
        this.setState(
            {
                loading: true,
            },
            () => {
                let postData = {
                    poId: this.params.poId,
                };

                $.ajax({
                    url: "/mg/po/essa-one/po-item-list",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(postData),
                    success: (res) => {
                        let data = {
                            loading: false,
                        };
                        if (res.success && res.valid) {
                            data = Object.assign(data, {
                                itemList:
                                    (res.model && res.model.itemList) || [],
                                cancelItemList:
                                    (res.model && res.model.cancelItemList) ||
                                    [],
                                registerCancelItemList:
                                    (res.model && res.model.registerCancelItemList) ||
                                    [],
                                registerCancelData: (res.model && res.model.registerCancelData) ||{},
                                extra: res.extra || {},
                            });
                        }
                        this.setState(data);
                    },
                    error: () => {
                        let data = {
                            loading: false,
                        };
                        this.setState(data);
                    },
                });
            }
        );
    }

    /**
     * 获取po单头数据
     */
    getPoHead() {
        $.ajax({
            url: "/mg/po/essa-one/po-header",
            type: "post",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                id: this.params.poId,
            }),
            success: (res) => {
                if (res.success && res.valid) {
                    this.setState({
                        model: res.model || {},
                    });
                }
            },
        });
    }
    /**
     * 获取理赔详情
     * */
    getPayMoney(currencySymbol='',arriveLatePayAmount=0){
        const m = Math.round(arriveLatePayAmount * 100) / 100;
        return m > 0 ? currencySymbol+''+m: 0;
    }

    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    // downExcel(poId){
    //     const currLocaleLang = Locale.current();
    //     const url =  config.servers[config.environment].exportApi +'/data/bpms/jreport/poexport/child-order-goods-print?template='+'DdpPoGoodsExportReport_'+currLocaleLang
    //         +'&token='+getRandomString(15)+'&pwd='+getRandomString(8)+'&langCode='+currLocaleLang+'&timestamps='+new Date().getTime()+'&lang='+currLocaleLang+'&isGetHttpConfig=true&isCheck=0&poId='+poId;
    //     window.open(url);
    // }
    /*
    * 客户不要了
    * */
    openAbandonModal(flag=false){
        console.log("点击")
        this.setState({
            showAbandonModal:flag,
        })
    }
    init(){
        const {fxUserId} = Cookie.getJSON("fmg.extra") || {};
        this.setState({
            fxUserId:fxUserId||""
        })
    }
    componentDidMount() {
        this.init();
        this.getPoHead();
        this.getData();
    }

    render() {
        let { loading, cancelItemList, registerCancelItemList,itemList, model,registerCancelData,fxUserId,showAbandonModal=false } = this.state;
        let skuIds = [];
        if (itemList.length > 0 || cancelItemList.length > 0) {
            for (var i = 0; i < itemList.length; i++) {
                skuIds.push(itemList[i].skuId);
            }
            for (i = 0; i < cancelItemList.length; i++) {
                skuIds.push(cancelItemList[i].skuId);
            }
            if (skuIds.length > 0) {
                skuIds = skuIds.join(",");
            } else {
                skuIds = "";
            }
        }
        return (
            <div>
                {isEmpty(fxUserId)&&<CommonBreadcrumb
                    list={[
                        // { name: __getServerLanguage('PoDanLieBiao'), link: `/order/sale` },
                        { name: model.noCertificateSplit==1?__getServerLanguage('ZhongGuoZhiFaDingDan'):__getServerLanguage('PoDanLieBiao'),
                            link: model.noCertificateSplit==1?`/order/directSale`:`/order/sale`
                        },
                        { name: __getServerLanguage('NingDePODanOne') },
                    ]}
                ></CommonBreadcrumb>}
                {model.statusBuyer!=-10&&model.arriveLate&&<div className={'alert-warning-pay'}>
                    <Tooltip placement="topLeft" title={__getServerLanguage('DingDanWanDaoShiJianChaoGhuNian')} arrow>
                        <i className="iconfont icon-xinxix margin-right-5"></i>
                    </Tooltip>
                    <span dangerouslySetInnerHTML={{ __html: __getServerLanguage('NinDeDingDanBiYuQiWanDaoLe',`<span class="color-danger">${model.arriveLateDay}</span>`,`<span class="color-danger"> ${this.getPayMoney(model.currencySymbol,model.arriveLatePayAmount)}</span>`) }}></span>
                </div>}
                <div className="main-wrap po-detail-wrap">
                    {/*订单信息*/}
                    <SmallPo
                        model={model}
                        itemList={itemList}
                        callBack={this.getPoHead.bind(this)}
                    ></SmallPo>

                    <Spin spinning={loading}>
                        <div className="content-main">
                            <div className="count-title mt_20">
                                <div>
                                <span className="name">
                                    {model.isSplitOrder === 1
                                        ? __getServerLanguage(
                                              "BenChaiFenDingDanShangPinQingDan"
                                          )
                                        : __getServerLanguage(
                                              "CaiGouShangPinQingDan"
                                          )}
                                </span>
                                <span className="count">
                                    {__getServerLanguage(
                                        "ZongGongKuanXiangShangPinZongJia",
                                        model.itemCount,
                                        model.totalQuantity,
                                        `${
                                            model.currencySymbol
                                        } ${numberWithCommas(
                                            model.exwPriceTotal
                                        )}`
                                    )}
                                </span>
                                </div>
                                {/*<div>*/}
                                    {/*<Button  className={"mr_8"} onClick={()=>this.downExcel(model.id)} >*/}
                                        {/*{Lang({id: "PODanDaoChu", default: "PO单导出"})}*/}
                                    {/*</Button>*/}
                                    {/*/!*<ProdRequirementsDrawer className={"mr_8"} poId={model.id} refresh={()=>this.getPoHead()}>*!/*/}
                                        {/*/!*<Button className={model.poItemRequireCount&&model.poItemRequireCount>0?"btn_pink":""}>{Lang({id: "ShengChanYaoQiu", default: "生产要求"})}*!/*/}
                                            {/*/!*{model.poItemRequireCount&&model.poItemRequireCount>0?<span className={"ml_2"}>({model.poItemRequireCount})</span>:null}*!/*/}
                                        {/*/!*</Button>*!/*/}
                                    {/*/!*</ProdRequirementsDrawer>*!/*/}
                                    {/*/!* 分销商 账号不能 取消登记 *!/*/}
                                    {/*{itemList.length>0&&isEmpty(fxUserId)&&<Button onClick={()=>this.getCancelRegistration(model.code)} >{Lang({id: "QuXiaoDengJi", default: "取消登记"})}</Button>}*/}
                                {/*</div>*/}
                            </div>

                            {/*商品清单*/}
                            {itemList.length > 0 ?
                                <List
                                    callBack={() => {
                                        this.getPoHead();
                                        this.getData();
                                    }}
                                    refreshList={() =>this.getData()}
                                    list={itemList}
                                    model={model}
                                ></List>:null
                            }
                        </div>
                        {/*已取消商品*/}
                        {cancelItemList.length > 0 ? (
                            <div className={`poDetail-cancel-wrap ${itemList.length > 0 ?'hide-title':''}`}>
                                <div className="title">
                                    {__getServerLanguage("YiQuXiaoShangPin")}
                                </div>
                                <List
                                    callBack={() => {
                                        this.getPoHead();
                                        this.getData();
                                    }}
                                    list={cancelItemList}
                                    model={model}
                                    type="cancel"
                                ></List>
                            </div>
                        ) : null}
                        {/*出货后取消商品列表*/}
                        {registerCancelItemList.length > 0 ? (
                            <div>
                                <div className="count-title">
                                    <div>
                                           <span className="name">
                                                {Lang({id:'ChuHuoHouQuXiaoShangPin',default:'出货后取消商品'})}
                                            </span>
                                        {registerCancelData&&registerCancelData.itemCount&&<span className="count">
                                            {__getServerLanguage(
                                                "ZongGongNKuanNXiang",
                                                registerCancelData.itemCount,
                                                registerCancelData.totalQuantity
                                            )}
                                        </span>}
                                    </div>
                                </div>
                                {registerCancelItemList.map((item,index)=><div key={index}>
                                    {item.cancelOrderCode&&<div className={'cancelPoTitle'}>{Lang({id:'QuXiaoDanHao',default:'取消单号'})}：{item.cancelOrderCode}</div>}
                                    {item.registerCancelSkuList&&item.registerCancelSkuList.length>0&&<List
                                        callBack={() => {
                                            this.getPoHead();
                                            this.getData();
                                        }}
                                        list={item.registerCancelSkuList}
                                        model={model}
                                        expandSixPicture={false}
                                        showCancleRemark={true}
                                    ></List>}

                                </div>)}
                            </div>
                        ) : null}
                        {!loading &&
                        itemList.length < 1 &&
                        cancelItemList.length < 1 ? (
                            <div className="content-main">
                                <Empty></Empty>
                            </div>
                        ) : null}
                    </Spin>
                </div>
            </div>);
    }
}

PoDetail.defaultProps = {};

PoDetail.propTypes = {};
export default PoDetail;
